export const PARTNER_TYPE_EMPTY = '' as const
export const PARTNER_TYPE_MANUFACTURER = 'manufacturer' as const
export const PARTNER_TYPE_HARDWARE_SUPPLIER = 'hardware_supplier' as const

export type PartnerType = typeof PARTNER_TYPE_EMPTY | typeof PARTNER_TYPE_MANUFACTURER | typeof PARTNER_TYPE_HARDWARE_SUPPLIER

export const PARTNER_TYPES = {
  EMPTY: PARTNER_TYPE_EMPTY,
  MANUFACTURER: PARTNER_TYPE_MANUFACTURER,
  HARDWARE_SUPPLIER: PARTNER_TYPE_HARDWARE_SUPPLIER,
} as const

